import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './index.css';

// SPA-redirect: 404.html сохраняет исходный путь в sessionStorage, восстанавливаем.
const redirect = sessionStorage.getItem('redirect');
if (redirect && redirect !== '/') {
  sessionStorage.removeItem('redirect');
  history.replaceState(null, '', redirect);
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
